import PipelineStagesAPI from '../../api/saas/pipelineStages';

const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

const getters = {
  getStages($state) {
    return $state.records;
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
};

const actions = {
  async get({ commit }, pipelineId) {
    if (!pipelineId) return;
    commit('SET_PIPELINE_STAGES_UI_FLAG', { isFetching: true });
    try {
      const response = await PipelineStagesAPI.getStages(pipelineId);
      commit('SET_PIPELINE_STAGES', response.data);
    } catch (error) {
      // Ignore
    } finally {
      commit('SET_PIPELINE_STAGES_UI_FLAG', { isFetching: false });
    }
  },
  async create({ commit }, { pipelineId, stageData }) {
    commit('SET_PIPELINE_STAGES_UI_FLAG', { isCreating: true });
    try {
      const response = await PipelineStagesAPI.createStage(
        pipelineId,
        stageData
      );
      commit('ADD_PIPELINE_STAGE', response.data);
      return response.data;
    } finally {
      commit('SET_PIPELINE_STAGES_UI_FLAG', { isCreating: false });
    }
  },
  async update({ commit }, { pipelineId, id, ...stageData }) {
    commit('SET_PIPELINE_STAGES_UI_FLAG', { isUpdating: true });
    try {
      const response = await PipelineStagesAPI.updateStage(
        pipelineId,
        id,
        stageData
      );
      commit('UPDATE_PIPELINE_STAGE', response.data);
      return response.data;
    } finally {
      commit('SET_PIPELINE_STAGES_UI_FLAG', { isUpdating: false });
    }
  },
  async delete({ commit }, { pipelineId, id }) {
    commit('SET_PIPELINE_STAGES_UI_FLAG', { isDeleting: true });
    try {
      await PipelineStagesAPI.deleteStage(pipelineId, id);
      commit('DELETE_PIPELINE_STAGE', id);
    } finally {
      commit('SET_PIPELINE_STAGES_UI_FLAG', { isDeleting: false });
    }
  },
};

const mutations = {
  SET_PIPELINE_STAGES_UI_FLAG($state, data) {
    $state.uiFlags = { ...$state.uiFlags, ...data };
  },
  SET_PIPELINE_STAGES($state, data) {
    $state.records = data;
  },
  ADD_PIPELINE_STAGE($state, data) {
    $state.records.push(data);
  },
  UPDATE_PIPELINE_STAGE($state, data) {
    const idx = $state.records.findIndex(s => s.id === data.id);
    if (idx !== -1) {
      $state.records.splice(idx, 1, data);
    }
  },
  DELETE_PIPELINE_STAGE($state, id) {
    $state.records = $state.records.filter(s => s.id !== id);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
